import { mapMutations, mapState } from 'vuex'

export default {
    data () {
        return {
            moveCanvasKeyPressed: false,
            scenarioViewMoveInProgress: false,
            moveLastPosition: [0, 0]
        }
    },
    mounted () {
        this.$nextTick(() => {
            const element = this.$refs.scenarioRootRef
            const width = element.offsetWidth
            const buffer = 150
            this.setViewOffsetPosition([width / 2 - buffer, 30])
        })
    },
    computed: {
        ...mapState('debug', ['scenarioViewOffsetPosition', 'request_id']),
        scenarioStyle () {
            const offsetPosition = this.scenarioViewOffsetPosition
            return {
                left: offsetPosition[0] + 'px',
                top: offsetPosition[1] + 'px'
            }
        },
        scenarioClasses () {
            const returnClasses = []
            if (this.moveCanvasKeyPressed) {
                if (this.scenarioViewMoveInProgress) {
                    returnClasses.push('move-in-process')
                } else {
                    returnClasses.push('move-active')
                }
            }
            return returnClasses
        }
    },
    methods: {
        ...mapMutations('debug', ['setViewOffsetPosition', 'setZoomLevel']),
        mouseUpMoveScenario (e) {
            document.removeEventListener('mousemove', this.mouseMoveScenario)
            this.scenarioViewMoveInProgress = false
        },
        mouseDownMoveScenario (e) {
            if (e.button === 0) {
                this.moveCanvasKeyPressed = true
            }
            if (!this.moveCanvasKeyPressed) {
                return
            }
            if (e.button !== 1) {
                this.scenarioViewMoveInProgress = true
            }
            const [x, y] = this.getMousePosition(e)
            this.moveLastPosition[0] = x
            this.moveLastPosition[1] = y
            document.addEventListener('mousemove', this.mouseMoveScenario)
        },
        mouseMoveScenario (e) {
            if (e.buttons === 4) {
                this.scenarioViewMoveInProgress = true
            }
            if (e.buttons === 0) {
            // Mouse button is not pressed anymore so stop selection mode
            // Happens normally when mouse leave the view pressed and then
            // comes back unpressed.
            // @ts-ignore
                this.mouseUpMoveScenario(e)
                return
            }
            this.moveScenario(e)
        },
        moveScenario (e) {
            const [x, y] = this.getMousePosition(e)
            const scenarioViewOffsetPositionX = this.scenarioViewOffsetPosition[0] + (x - this.moveLastPosition[0])
            const scenarioViewOffsetPositionY = this.scenarioViewOffsetPosition[1] + (y - this.moveLastPosition[1])
            this.setViewOffsetPosition([scenarioViewOffsetPositionX, scenarioViewOffsetPositionY])
            // Update the last position
            this.moveLastPosition[0] = x
            this.moveLastPosition[1] = y
        },
        getMousePosition (e) {
            const x =
            e instanceof MouseEvent
                ? e.pageX
                : e.touches && e.touches[0] && e.touches[0].pageX
                    ? e.touches[0].pageX
                    : 0
            const y =
            e instanceof MouseEvent
                ? e.pageY
                : e.touches && e.touches[0] && e.touches[0].pageY
                    ? e.touches[0].pageY
                    : 0

            return [x, y]
        }
    },
    watch: {
        request_id () {
            const element = this.$refs.scenarioRootRef
            const width = element.offsetWidth
            const buffer = 150
            this.setZoomLevel({ scale: 1, offset: [width / 2 - buffer, 30] })
        }
    }
}
